import { app, ojs, Component } from "modular-openscriptjs";
import { either, randomInt } from "../../../helpers";
import { dom } from "../../../fotastart";
import InfiniteScroll from "../../Blocks/InfiniteScroll";
import FeaturedBusinessView from "./FeaturedBusinessView";
import Spinner from "../../Blocks/Spinner";
import { routes } from "../../../declarations";

const h = app("h");
const api = app("api");
const broker = app("broker");
const $e = app("$e");
const gc = app("gc");

ojs(InfiniteScroll, FeaturedBusinessView, Spinner);

export default class FeaturedBusinesses extends Component {
	pageMap = null;

	initMap() {
		if (this.pageMap == null) this.pageMap = 0;
	}

	render(config, ...args) {
		this.initMap();

		let attributes = config?.attributes ?? {
			class: "d-flex flex-row overflow-auto gap-3 p-1 pb-3 hide-scrollbar",
		};

		return h.InfiniteScroll({
			child: h.div(
				{
					fb_holder_id: `c-featured-businesses`,
				},
				...args
			),
			callback: (entries, observer, marker) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return;
					this.getBusinesses(
						marker,
						`c-featured-businesses`,
						attributes
					);
				});
			},
			managed: true,
		});
	}

	$$ojs = {
		beforeRouteChange: () => {
			this.cleanUp();
		},
	};

	cleanUp() {
		super.cleanUp();
		this.pageMap = null;
	}

	async getBusinesses(marker, holderId, attributes) {
		this.pageMap++;

		let page = this.pageMap;

		let spinner = h.Spinner({
			class: "p-3 my-auto mx-auto",
			parent: marker,
			resetParent: true,
		});

		let res = await api.get(
			`${routes.businesses}/featured`,
			{
				page,
			},
			{ silent: true }
		);

		if (res && res.data && res.data.businesses) {
			let businesses = res.data.businesses.data ?? [];

			for (let u of businesses) {
				dom.all(`[fb-holder-id='${holderId}']`)?.forEach((holder) => {
					let v = h.FeaturedBusinessView(u, attributes);
					let m = dom.get(`[ifs-marker='true']`, holder);
					m.classList.add("me-3");

					holder.insertBefore(v, m);
				});
			}

			if (!businesses?.length) {
				this.pageMap = page - 1;

				if (page == 1) {
					broker.send($e.app.messages.noBusinessToSuggest);
				}
			}
		}

		spinner.remove();
	}
}
